module.exports = "<dc-portlet title=\"{{::'securitySettings.changed.title' | i18n}}\"\n            no-padding-bottom=\"true\"\n            helptext=\"securitySettings.changed.text\"\n            help-popup=false>\n\n  <portlet-body>\n    <ul class=\"border-list editable\">\n      <li data-i18n=\"securitySettings.changed.text\"/>\n    </ul>\n  </portlet-body>\n</dc-portlet>"


//////////////////
// WEBPACK FOOTER
// ./src/ui/modules/eaSettings/eaProfile/components/eaSecurityQuestion/eaSecuritySettingsChanged.tpl.html
// module id = 1057
// module chunks = 12